<template>
  <div class="flex min-h-screen bg-white dark:bg-black">
    <div class="w-full p-4 md:p-8 mt-12 md:mt-0 lg:p-16 dark:bg-black">
      <div class="w-full bg-white dark:bg-black md:p-8 lg:p-12 relative">
        <div class="flex items-center justify-center space-x-2 mb-8 relative">
          <router-link to="/home" class="flex items-center">
            <img src="Logo-PG.svg" alt="Logo" class="h-10 w-auto" />
          </router-link>
        </div>

        <h2
          class="text-3xl font-bold mb-6 text-left text-gray-800 dark:text-white"
        >
          Sign Up
        </h2>
        <form @submit.prevent="signup">
          <div class="mb-4">
            <label
              class="block text-sm font-medium text-gray-700 dark:text-gray-300"
              >First Name</label
            >
            <input
              v-model="first_name"
              placeholder="Enter your first name"
              type="text"
              class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9] dark:bg-[#1A1A1A] dark:text-white dark:border-gray-800"
              required
            />
          </div>
          <div class="mb-4">
            <label
              class="block text-sm font-medium text-gray-700 dark:text-gray-300"
              >Last Name</label
            >
            <input
              v-model="last_name"
              placeholder="Enter your last name"
              type="text"
              class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9] dark:bg-[#1A1A1A] dark:text-white dark:border-gray-800"
              required
            />
          </div>
          <div class="mb-4">
            <label
              class="block text-sm font-medium text-gray-700 dark:text-gray-300"
              >Email</label
            >
            <input
              v-model="email"
              placeholder="user@example.com"
              type="email"
              class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9] dark:bg-[#1A1A1A] dark:text-white dark:border-gray-800"
              required
            />
          </div>
          <div class="mb-4">
            <label
              class="block text-sm font-medium text-gray-700 dark:text-gray-300"
              >Password</label
            >
            <div class="relative">
              <input
                v-model="password"
                @input="validatePassword"
                :type="showPassword ? 'text' : 'password'"
                placeholder="Enter your password"
                class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9] dark:bg-[#1A1A1A] dark:text-white dark:border-gray-800"
                required
              />
              <span
                @click="togglePassword"
                class="absolute inset-y-0 right-2 flex items-center cursor-pointer"
              >
                <svg
                  v-if="showPassword"
                  xmlns="http://www.w3.org/2000/svg"
                  height="14"
                  width="14"
                  viewBox="0 0 24 24"
                  class="text-gray-900 dark:text-gray-100"
                >
                  <title>hide</title>
                  <g
                    stroke-linejoin="miter"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="butt"
                    class="nc-icon-wrapper"
                  >
                    <path
                      d="M1.373,13.183a2.064,2.064,0,0,1,0-2.366C2.946,8.59,6.819,4,12,4s9.054,4.59,10.627,6.817a2.064,2.064,0,0,1,0,2.366C21.054,15.41,17.181,20,12,20S2.946,15.41,1.373,13.183Z"
                      stroke-linecap="square"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    ></path>
                    <circle
                      data-color="color-2"
                      cx="12"
                      cy="12"
                      r="4"
                      stroke-linecap="square"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    ></circle>
                    <line
                      data-color="color-2"
                      x1="2"
                      y1="22"
                      x2="22"
                      y2="2"
                      stroke-linecap="square"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    ></line>
                  </g>
                </svg>
                <svg
                  v-if="!showPassword"
                  xmlns="http://www.w3.org/2000/svg"
                  height="14"
                  width="14"
                  viewBox="0 0 24 24"
                  class="text-gray-900 dark:text-gray-100"
                >
                  <title>view</title>
                  <g
                    stroke-linejoin="miter"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="butt"
                    class="nc-icon-wrapper"
                  >
                    <path
                      d="M1.373,13.183a2.064,2.064,0,0,1,0-2.366C2.946,8.59,6.819,4,12,4s9.054,4.59,10.627,6.817a2.064,2.064,0,0,1,0,2.366C21.054,15.41,17.181,20,12,20S2.946,15.41,1.373,13.183Z"
                      stroke-linecap="square"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    ></path>
                    <circle
                      data-color="color-2"
                      cx="12"
                      cy="12"
                      r="4"
                      stroke-linecap="square"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    ></circle>
                  </g>
                </svg>
              </span>
            </div>

            <div class="mt-2 text-[14px] grid grid-cols-1 md:grid-cols-2 gap-4">
              <div
                :class="getValidationClass(passwordCriteria.length)"
                class="flex items-center gap-2"
              >
                At least 8 characters
                <span class="inline-block w-4 h-4">
                  <span v-if="passwordCriteria.length" class="text-green-500"
                    >✔</span
                  >
                  <span v-else class="text-red-500">
                    <img
                      src="@/assets/dashboard/iconoir_cancel.svg"
                      alt="Close"
                      class="w-5 h-5"
                    />
                  </span>
                </span>
              </div>
              <div
                :class="getValidationClass(passwordCriteria.uppercase)"
                class="flex items-center gap-2"
              >
                At least one uppercase letter
                <span class="inline-block w-4 h-4">
                  <span v-if="passwordCriteria.uppercase" class="text-green-500"
                    >✔</span
                  >
                  <span v-else class="text-red-500">
                    <img
                      src="@/assets/dashboard/iconoir_cancel.svg"
                      alt="Close"
                      class="w-5 h-5"
                    />
                  </span>
                </span>
              </div>
              <div
                :class="getValidationClass(passwordCriteria.number)"
                class="flex items-center gap-2"
              >
                At least one number
                <span class="inline-block w-4 h-4">
                  <span v-if="passwordCriteria.number" class="text-green-500"
                    >✔</span
                  >
                  <span v-else class="text-red-500">
                    <img
                      src="@/assets/dashboard/iconoir_cancel.svg"
                      alt="Close"
                      class="w-5 h-5"
                    />
                  </span>
                </span>
              </div>
              <div
                :class="getValidationClass(passwordCriteria.specialChar)"
                class="flex items-center gap-2"
              >
                At least one special character
                <span class="inline-block w-4 h-4">
                  <span
                    v-if="passwordCriteria.specialChar"
                    class="text-green-500"
                    >✔</span
                  >
                  <span v-else class="text-red-500">
                    <img
                      src="@/assets/dashboard/iconoir_cancel.svg"
                      alt="Close"
                      class="w-5 h-5"
                    />
                  </span>
                </span>
              </div>
            </div>
          </div>
          <button
            type="submit"
            class="w-full py-2 px-4 bg-primaryDarkBg hover:bg-primaryDark text-white font-bold rounded"
            :disabled="loading"
          >
            <span v-if="loading" class="spinner"></span>
            <span v-else>Create an account</span>
          </button>
        </form>

        <div class="space-y-4">
          <p class="mb-2 mt-4 text-grayDark dark:text-gray-400 text-sm">
            By clicking “Create account” above, you acknowledge that you have
            read, understood, and agree with Company’s Privacy Policy and Terms
            Of Service
          </p>
          <hr
            class="w-full border-t-[1px] border-grayLight dark:border-gray-800 mb-6"
          />
          <p
            class="mt-6 text-primaryDark dark:text-white flex justify-between items-center text-sm"
          >
            Already have an account?
            <router-link
              to="/login"
              class="text-primaryDark dark:text-blue-400 hover:underline px-3 py-2 bg-[#EEEEEE] dark:bg-[#1A1A1A] rounded-md transition-colors"
              >Sign In</router-link
            >
          </p>
        </div>
      </div>
    </div>
    <div
      class="hidden md:block w-full transition-colors border-l dark:border-gray-800 sticky top-0 h-screen overflow-hidden"
    >
      <img
        src="/login-bg-img.png"
        alt="Sign Up Background"
        class="object-cover w-full h-full"
      />
    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";
import { useRouter } from "vue-router";

export default {
  name: "SignupView",
  data() {
    return {
      showPassword: false,
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      password: "",
      loading: false,
      passwordCriteria: {
        length: false,
        uppercase: false,
        number: false,
        specialChar: false,
      },
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  setup() {
    const router = useRouter();
    return { router };
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    validatePassword() {
      const password = this.password;
      this.passwordCriteria.length = password.length >= 8;
      this.passwordCriteria.uppercase = /[A-Z]/.test(password);
      this.passwordCriteria.number = /[0-9]/.test(password);
      this.passwordCriteria.specialChar =
        /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password);
    },
    getValidationClass(criteriaMet) {
      return criteriaMet
        ? "text-primaryDark dark:text-blue-400"
        : "text-grayDark dark:text-gray-500";
    },

    async signup() {
      const isPasswordStrong = Object.values(this.passwordCriteria).every(
        (value) => value,
      );
      if (!isPasswordStrong) {
        const failures = [];
        if (!this.passwordCriteria.length)
          failures.push("at least 8 characters");
        if (!this.passwordCriteria.uppercase)
          failures.push("at least one uppercase letter");
        if (!this.passwordCriteria.number) failures.push("at least one number");
        if (!this.passwordCriteria.specialChar)
          failures.push("at least one special character");

        this.$toast.error(
          "Weak Password",
          "Password must contain: " + failures.join(", ")
        );
        return;
      }

      this.loading = true;

      try {
        const payload = {
          email: this.email,
          first_name: this.first_name,
          last_name: this.last_name,
          role: "user",
          phone: this.phone,
          password: this.password,
          is_superuser: false,
          date_created: new Date().toISOString(),
        };

        await apiClient.post("/web/users", payload, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        
        this.$toast.success(
          "Account Created",
          "Your account has been created successfully. Please verify your email."
        );
        
        this.$router.push({
          name: "VerifyEmail",
          params: { email: this.email },
        });
      } catch (error) {
        console.error("Error creating user:", error);
        
        const errorMessage = error.response?.data?.message || "An unexpected error occurred while creating your account.";
        this.$toast.error("Signup Failed", errorMessage);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.spinner {
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* Autofill styling for dark mode */
.dark input:-webkit-autofill,
.dark input:-webkit-autofill:hover,
.dark input:-webkit-autofill:focus,
.dark textarea:-webkit-autofill,
.dark textarea:-webkit-autofill:hover,
.dark textarea:-webkit-autofill:focus,
.dark select:-webkit-autofill,
.dark select:-webkit-autofill:hover,
.dark select:-webkit-autofill:focus {
  -webkit-text-fill-color: white !important;
  -webkit-box-shadow: 0 0 0px 1000px #0a0a0a inset !important;
  transition: background-color 5000s ease-in-out 0s;
}
</style>
